import { closestCorners } from '@dnd-kit/core'

const edgeSensitiveCollisionDetection = (args, activeId) => {
  const collisions = closestCorners(args)

  if (!activeId) return collisions

  const [type] = activeId.split('__') // Extract type (e.g., "section" or "card")

  if (type === 'section') {
    // Filter collisions to include only sections
    const filteredCollisions = collisions.filter(({ id }) =>
      id.startsWith('section__'),
    )

    // Add bias toward top and bottom edges of sections
    return filteredCollisions
      .map(collision => {
        const element = document.getElementById(collision.id) // Get section element by ID
        const rect = element?.getBoundingClientRect()

        if (rect) {
          const middleY = (rect.top + rect.bottom) / 2 // Calculate vertical midpoint
          const distanceToEdge =
            collision.point.y < middleY
              ? Math.abs(collision.point.y - rect.top) // Distance to top edge
              : Math.abs(collision.point.y - rect.bottom) // Distance to bottom edge

          return { ...collision, distanceToEdge }
        }
        return collision
      })
      .sort((a, b) => a.distanceToEdge - b.distanceToEdge) // Sort by proximity to edges
  }

  // Default behavior for other types
  return collisions
}

export default edgeSensitiveCollisionDetection
